import { NavigateFunction } from 'react-router-dom';

import { ImageCardProps, Tool, ActionStickerCardProps } from '@backrs_ui/common-ui';

import CareerPaths from '@backrs_ui/common-ui/src/assets/images/career-paths.png';
import CompetencyLibrary from '@backrs_ui/common-ui/src/assets/images/competency-library.png';
import ExploreEmployers from '@backrs_ui/common-ui/src/assets/images/explore-employers.png';
import ExploreInternships from '@backrs_ui/common-ui/src/assets/images/explore-internships.png';
import ExploreMajors from '@backrs_ui/common-ui/src/assets/images/explore-majors.png';
import ExploreScholarships from '@backrs_ui/common-ui/src/assets/images/explore-scholarships.png';
import ExploreUniversities from '@backrs_ui/common-ui/src/assets/images/explore-universities.png';
import LifeReadiness from '@backrs_ui/common-ui/src/assets/images/life-readiness.png';
import Achievement from '@backrs_ui/common-ui/src/assets/images/stickers/Achievement.png';
import Audiobook from '@backrs_ui/common-ui/src/assets/images/stickers/Audiobook.png';
import BlueResume from '@backrs_ui/common-ui/src/assets/images/stickers/BlueResume.png';
import BooksWriting from '@backrs_ui/common-ui/src/assets/images/stickers/BooksWriting.png';
import Calendar from '@backrs_ui/common-ui/src/assets/images/stickers/Calendar.png';
import Chances from '@backrs_ui/common-ui/src/assets/images/stickers/Chances.png';
import Comedy from '@backrs_ui/common-ui/src/assets/images/stickers/Comedy.png';
import Computer from '@backrs_ui/common-ui/src/assets/images/stickers/Computer.png';
import ContactCard from '@backrs_ui/common-ui/src/assets/images/stickers/ContactCard.png';
import CraftsDIY from '@backrs_ui/common-ui/src/assets/images/stickers/CraftsDIY.png';
import DancingShoes from '@backrs_ui/common-ui/src/assets/images/stickers/DancingShoes.png';
import DataChart from '@backrs_ui/common-ui/src/assets/images/stickers/DataChart.png';
import DesignTech from '@backrs_ui/common-ui/src/assets/images/stickers/DesignTech.png';
import DesignTechGreen from '@backrs_ui/common-ui/src/assets/images/stickers/DesignTechGreen.png';
import DocumentFolder from '@backrs_ui/common-ui/src/assets/images/stickers/DocumentFolder.png';
import Flag from '@backrs_ui/common-ui/src/assets/images/stickers/Flag.png';
import Games from '@backrs_ui/common-ui/src/assets/images/stickers/Games.png';
import GradCap from '@backrs_ui/common-ui/src/assets/images/stickers/GradCap.png';
import JobsPaths from '@backrs_ui/common-ui/src/assets/images/stickers/JobsPaths.png';
import Launch from '@backrs_ui/common-ui/src/assets/images/stickers/Launch.png';
import MagnifyingGlass from '@backrs_ui/common-ui/src/assets/images/stickers/MagnifyingGlass.png';
import Merchandise from '@backrs_ui/common-ui/src/assets/images/stickers/Merchandise.png';
import Microphone from '@backrs_ui/common-ui/src/assets/images/stickers/Microphone.png';
import Money from '@backrs_ui/common-ui/src/assets/images/stickers/Money.png';
import Newspaper from '@backrs_ui/common-ui/src/assets/images/stickers/Newspaper.png';
import Podcast from '@backrs_ui/common-ui/src/assets/images/stickers/Podcast.png';
import PriceTag from '@backrs_ui/common-ui/src/assets/images/stickers/PriceTag.png';
import Receipt from '@backrs_ui/common-ui/src/assets/images/stickers/Receipt.png';
import Resume from '@backrs_ui/common-ui/src/assets/images/stickers/Resume.png';
import RocketShip from '@backrs_ui/common-ui/src/assets/images/stickers/RocketShip.png';
import SleepCloud from '@backrs_ui/common-ui/src/assets/images/stickers/SleepCloud.png';
import StressThought from '@backrs_ui/common-ui/src/assets/images/stickers/StressThought.png';
import Studying from '@backrs_ui/common-ui/src/assets/images/stickers/Studying.png';
import ThumbsUp from '@backrs_ui/common-ui/src/assets/images/stickers/ThumbsUp.png';
import VideoCamera from '@backrs_ui/common-ui/src/assets/images/stickers/VideoCamera.png';
import Waving from '@backrs_ui/common-ui/src/assets/images/stickers/Waving.png';
import { APP_ROUTE } from '@backrs_ui/grow-ui/src/appRoutes.constants';
import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';
import {
  OFFICE_HOURS_SESSION_IDS,
  SOLUTION_SESSION_IDS,
} from '@backrs_ui/grow-ui/src/models/models';
import { SEARCH_PAGE_CATEGORIES } from '@backrs_ui/grow-ui/src/pages/Search/search.types';
import { selectContentCompetencies } from '@backrs_ui/grow-ui/src/redux/contentCompetency/contentCompetency';
import { useAppSelector } from '@backrs_ui/grow-ui/src/redux/hooks';
import { useGetToolsQuery } from '@backrs_ui/grow-ui/src/redux/tools/tools.api';

const BACKRS_APP_URL = process.env.REACT_APP_BACKRS_URL;

const BUILD_STRONG_PROFILE_STRINGS = appStrings.modules.home.sections.upYourGame.buildStrongProfile;
const EXPLORE_CAREER_STRINGS = appStrings.modules.home.sections.upYourGame.exploreCareers;
const BUILD_SOCIAL_CAPITAL_STRINGS = appStrings.modules.home.sections.upYourGame.buildSocialCapital;

const ATTAIN_FINANCIAL_FREEDOM_STRINGS =
  appStrings.modules.home.sections.personalHealthAndWellness.attainFinancialFreedom;
const BE_WELL_STRINGS = appStrings.modules.home.sections.personalHealthAndWellness.beWell;
const MASTER_MINDSETS_STRINGS =
  appStrings.modules.home.sections.personalHealthAndWellness.masterMindsets;

const GREAT_COLLEGE_STRINGS = appStrings.modules.home.sections.getBackedYourWay.greatCollege;
const SCORE_JOB_INTERNSHIP_STRINGS =
  appStrings.modules.home.sections.getBackedYourWay.scoreJobInternship;
const EXPLORE_OPPORTUNITIES_STRINGS = appStrings.modules.home.sections.exploreOpportunities;
const TOOLS_CARD_TITLES = appStrings.modules.tools.cardTitles;

export const ALL_STICKERS = {
  college_shortlist: 'college_shortlist',
  what_are_your_chances: 'what_are_your_chances',
  essay_ideas: 'essay_ideas',
  improve_test_scores: 'improve_test_scores',
  sat_act_booster: 'sat_act_booster',
  update_social_media: 'update_social_media',
  jobs_you_might_love: 'jobs_you_might_love',
  interviewing: 'interviewing',
  boost_odds_of_an_offer: 'boost_odds_of_an_offer',
  extra_cash: 'extra_cash',
  lower_cost_of_college: 'lower_cost_of_college',
  build_credit: 'build_credit',
  savings_and_investing: 'savings_and_investing',
  navigating_stress: 'navigating_stress',
  sleep_restoration: 'sleep_restoration',
  family_dynamics: 'family_dynamics',
  healthcare: 'healthcare',
  agency: 'agency',
  learn_to_learn: 'learn_to_learn',
  growth_mindset: 'growth_mindset',
  problem_solving: 'problem_solving',
  resume_optimizer: 'resume_optimizer',
  majors_and_courses: 'majors_and_courses',
  studying: 'studying',
  boost_your_profile: 'boost_your_profile',
  tracks_to_succeed: 'tracks_to_succeed',
  shadowing: 'shadowing',
  jobs_paths_for_you: 'jobs_paths_for_you',
  success_decoded: 'success_decoded',
  networking: 'networking',
  seek_support: 'seek_support',
  engage_teachers: 'engage_teachers',
  resume_builder: 'resume_builder',
  majors: 'majors',
  // the sticker versions of the image card (used on Onboarding recommendations)
  discover_jobs_sticker: 'discover_jobs_sticker',
  explore_universities_sticker: 'explore_universities_sticker',
  explore_employers_sticker: 'explore_employers_sticker',
  find_scholarships_sticker: 'find_scholarships_sticker',
  // onboarding specific cards
  back_individual_student: 'back_individual_student',
  engage_in_networks: 'engage_in_networks',
  explore_tools_dashboard: 'explore_tools_dashboard',
  respond_to_catch_up: 'respond_to_catch_up',
  share_your_story_video_ask: 'share_your_story_video_ask',
  // pages
  blueprint: 'blueprint',
  life_readiness: 'life_readiness',
  are_you_on_track: 'are_you_on_track',
  // majors guide tools
  majors_to_careers: 'majors_to_careers',
  explore_majors: 'explore_majors',
  careers_to_majors: 'careers_to_majors',
} as const;

export type StickerCardId = (typeof ALL_STICKERS)[keyof typeof ALL_STICKERS];

export type ImageCardId =
  | 'explore_universities_sticker'
  | 'explore_employers_sticker'
  | 'discover_jobs_sticker'
  | 'find_scholarships_sticker'
  | 'majors_and_courses'
  | 'competency_library'
  | 'life_readiness'
  | 'jobs_paths_for_you';

export type ToolId = StickerCardId | ImageCardId;

export type StickerCard = ActionStickerCardProps & {
  keywords: string[];
};

export type ImageCard = ImageCardProps & {
  keywords: string[];
};

type ToolMapProps = Readonly<{
  tools?: Tool[];
  toolId: ToolId;
  fallback: {
    title: string;
    description?: string;
    stickerUrl: string;
    keywords: string[];
    onClick: () => void;
  };
  navigate: NavigateFunction;
}>;

const toolMap = ({ tools, toolId, fallback, navigate }: ToolMapProps): StickerCard => {
  // for solution sessions with subsessions, we need to remove the subsession from the tool_id
  const toolIdWithoutSubsession = toolId ? toolId.split('.')[0] : undefined;

  const foundTool = tools?.find((tool) => tool.tool_id === toolIdWithoutSubsession);

  return {
    title: foundTool?.title || fallback?.title,
    description: foundTool?.description || fallback?.description,
    stickerUrl: foundTool?.media?.media_url || fallback?.stickerUrl || '/backrs.svg',
    keywords: foundTool?.keywords || fallback?.keywords,
    onClick: () => {
      // if we find a match for the tool, we'll navigate to the internal or external url
      if (foundTool) {
        if (foundTool.navigation.type === 'INTERNAL') {
          navigate(foundTool.navigation.internal_navigation_url);

          return;
        }

        window.open(foundTool.navigation.external_navigation_url, '_blank');

        return;
      }

      // if we don't find a match for the tool, we'll use the fallback navigation
      fallback.onClick();
    },
    tool: foundTool,
  };
};

type useToolCardByIdProps = Readonly<{
  navigate: NavigateFunction;
}>;

export const useToolCardById = ({ navigate }: useToolCardByIdProps) => {
  const { data: tools } = useGetToolsQuery(undefined);

  const competencies = useAppSelector(selectContentCompetencies).contentCompetencies;

  const getCompetencyUrl = (competencyTitle: string) => {
    const competencySlug = competencies.find(
      (competency) => competency.title.toLowerCase() === competencyTitle.toLowerCase(),
    )?.slug;

    // if we can't find the competency for some reason we'll just go to prosper
    return competencySlug ? `${APP_ROUTE.COMPETENCY}/${competencySlug}` : APP_ROUTE.LIBRARY;
  };

  const getStickerCard = (id: StickerCardId): StickerCard => {
    const TOOL_FALLBACKS: Record<StickerCardId, StickerCard> = {
      college_shortlist: {
        title: GREAT_COLLEGE_STRINGS.actionStickerCards.collegeShortlist.title,
        description: GREAT_COLLEGE_STRINGS.actionStickerCards.collegeShortlist.description,
        stickerUrl: Achievement,
        keywords: ['college', 'shortlist', 'vision', 'school', 'university'],
        onClick: () =>
          navigate(
            APP_ROUTE.OFFICE_HOURS_SESSION.replace(
              ':id',
              OFFICE_HOURS_SESSION_IDS.COLLEGE_SHORTLIST,
            ),
          ),
        tool: tools?.find((tool) => tool.tool_id === 'college_shortlist'),
      },
      what_are_your_chances: {
        title: GREAT_COLLEGE_STRINGS.actionStickerCards.whatAreYourChances.title,
        description: GREAT_COLLEGE_STRINGS.actionStickerCards.whatAreYourChances.description,
        stickerUrl: Chances,
        keywords: ['chances', 'admission', 'odds', 'improve', 'school', 'university'],
        onClick: () =>
          navigate(
            APP_ROUTE.OFFICE_HOURS_SESSION.replace(
              ':id',
              OFFICE_HOURS_SESSION_IDS.WHAT_ARE_YOUR_CHANCES,
            ),
          ),
        tool: tools?.find((tool) => tool.tool_id === 'what_are_your_chances'),
      },
      essay_ideas: {
        title: GREAT_COLLEGE_STRINGS.actionStickerCards.essayIdeas.title,
        description: GREAT_COLLEGE_STRINGS.actionStickerCards.essayIdeas.description,
        stickerUrl: BooksWriting,
        keywords: ['essay', 'ideas', 'personal', 'experiences', 'aspirations'],
        onClick: () =>
          navigate(
            APP_ROUTE.OFFICE_HOURS_SESSION.replace(':id', OFFICE_HOURS_SESSION_IDS.ESSAY_IDEAS),
          ),
      },
      improve_test_scores: {
        title: GREAT_COLLEGE_STRINGS.actionStickerCards.improveYourTestScores.title,
        description: GREAT_COLLEGE_STRINGS.actionStickerCards.improveYourTestScores.description,
        stickerUrl: DataChart,
        keywords: ['test', 'scores', 'ACT', 'SAT', 'improve', 'school', 'university'],
        onClick: () =>
          navigate(
            APP_ROUTE.OFFICE_HOURS_SESSION.replace(
              ':id',
              OFFICE_HOURS_SESSION_IDS.IMPROVE_YOUR_TEST_SCORES,
            ),
          ),
        tool: tools?.find((tool) => tool.tool_id === 'improve_test_scores'),
      },
      sat_act_booster: {
        title: GREAT_COLLEGE_STRINGS.actionStickerCards.testBooster.title,
        description: GREAT_COLLEGE_STRINGS.actionStickerCards.testBooster.description,
        stickerUrl: DataChart,
        keywords: ['act', 'sat', 'test', 'score', 'study', 'prep', 'college'],
        onClick: () => navigate(APP_ROUTE.SAT_ACT_BOOSTER),
        tool: tools?.find((tool) => tool.tool_id === 'sat_act_booster'),
      },
      resume_builder: {
        title: SCORE_JOB_INTERNSHIP_STRINGS.actionStickerCards.resumeBuilder.title,
        description: SCORE_JOB_INTERNSHIP_STRINGS.actionStickerCards.resumeBuilder.description,
        stickerUrl: BlueResume,
        keywords: ['resume', 'builder', 'job', 'application', 'career'],
        onClick: () =>
          navigate(APP_ROUTE.SOLUTION_SESSION.replace(':id?', SOLUTION_SESSION_IDS.RESUME_BUILDER)),
        tool: tools?.find((tool) => tool.tool_id === 'resume_builder'),
      },
      update_social_media: {
        title: SCORE_JOB_INTERNSHIP_STRINGS.actionStickerCards.updateSocialMedia.title,
        description: SCORE_JOB_INTERNSHIP_STRINGS.actionStickerCards.updateSocialMedia.description,
        stickerUrl: DesignTech,
        keywords: ['social', 'media', 'profile', 'odds'],
        onClick: () => navigate(getCompetencyUrl('Social media')),
        tool: tools?.find((tool) => tool.tool_id === 'update_social_media'),
      },
      jobs_you_might_love: {
        title: SCORE_JOB_INTERNSHIP_STRINGS.actionStickerCards.jobsYouMightLove.title,
        description: SCORE_JOB_INTERNSHIP_STRINGS.actionStickerCards.jobsYouMightLove.description,
        stickerUrl: Newspaper,
        keywords: ['career', 'paths', 'life', 'aspirations', 'preferences'],
        onClick: () =>
          navigate(
            APP_ROUTE.OFFICE_HOURS_SESSION.replace(
              ':id',
              OFFICE_HOURS_SESSION_IDS.JOBS_YOU_MIGHT_LOVE,
            ),
          ),
        tool: tools?.find((tool) => tool.tool_id === 'jobs_you_might_love'),
      },
      interviewing: {
        title: SCORE_JOB_INTERNSHIP_STRINGS.actionStickerCards.interviewing.title,
        description: SCORE_JOB_INTERNSHIP_STRINGS.actionStickerCards.interviewing.description,
        stickerUrl: Podcast,
        keywords: ['interview', 'confidence', 'fun'],
        onClick: () => navigate(getCompetencyUrl('Interviewing')),
        tool: tools?.find((tool) => tool.tool_id === 'interviewing'),
      },
      boost_odds_of_an_offer: {
        title: SCORE_JOB_INTERNSHIP_STRINGS.actionStickerCards.boostOfferOdds.title,
        description: SCORE_JOB_INTERNSHIP_STRINGS.actionStickerCards.boostOfferOdds.description,
        stickerUrl: Games,
        keywords: ['fit', 'role', 'offer', 'odds', 'improve'],
        onClick: () =>
          navigate(
            APP_ROUTE.OFFICE_HOURS_SESSION.replace(
              ':id',
              OFFICE_HOURS_SESSION_IDS.BOOST_ODDS_OF_AN_OFFER,
            ),
          ),
        tool: tools?.find((tool) => tool.tool_id === 'boost_odds_of_an_offer'),
      },
      extra_cash: {
        title: ATTAIN_FINANCIAL_FREEDOM_STRINGS.actionStickerCards.extraCash.title,
        description: ATTAIN_FINANCIAL_FREEDOM_STRINGS.actionStickerCards.extraCash.description,
        stickerUrl: Money,
        keywords: ['cash', 'extra', 'income', 'savings', 'investing'],
        onClick: () => navigate(getCompetencyUrl('Securing extra Cash')),
        tool: tools?.find((tool) => tool.tool_id === 'extra_cash'),
      },
      lower_cost_of_college: {
        title: ATTAIN_FINANCIAL_FREEDOM_STRINGS.actionStickerCards.lowerTheCostOfCollege.title,
        description:
          ATTAIN_FINANCIAL_FREEDOM_STRINGS.actionStickerCards.lowerTheCostOfCollege.description,
        stickerUrl: PriceTag,
        keywords: ['college', 'cost', 'affordable', 'tuition', 'scholarships', 'university'],
        onClick: () =>
          navigate(
            APP_ROUTE.OFFICE_HOURS_SESSION.replace(
              ':id',
              OFFICE_HOURS_SESSION_IDS.LOWER_COST_OF_COLLEGE,
            ),
          ),
        tool: tools?.find((tool) => tool.tool_id === 'lower_cost_of_college'),
      },
      build_credit: {
        title: ATTAIN_FINANCIAL_FREEDOM_STRINGS.actionStickerCards.buildCredit.title,
        description: ATTAIN_FINANCIAL_FREEDOM_STRINGS.actionStickerCards.buildCredit.description,
        stickerUrl: Receipt,
        keywords: ['credit', 'debt', 'score', 'financial', 'management'],
        onClick: () => navigate(getCompetencyUrl('Credit / Debt')),
        tool: tools?.find((tool) => tool.tool_id === 'build_credit'),
      },
      savings_and_investing: {
        title: ATTAIN_FINANCIAL_FREEDOM_STRINGS.actionStickerCards.savingsAndInvesting.title,
        description:
          ATTAIN_FINANCIAL_FREEDOM_STRINGS.actionStickerCards.savingsAndInvesting.description,
        stickerUrl: DocumentFolder,
        keywords: ['savings', 'investing', 'financial', 'planning', 'retirement'],
        onClick: () => navigate(getCompetencyUrl('Savings & investing')),
        tool: tools?.find((tool) => tool.tool_id === 'savings_and_investing'),
      },
      navigating_stress: {
        title: BE_WELL_STRINGS.actionStickerCards.navigatingStress.title,
        description: BE_WELL_STRINGS.actionStickerCards.navigatingStress.description,
        stickerUrl: StressThought,
        keywords: ['stress', 'anxiety', 'mindfulness', 'relaxation', 'wellness'],
        onClick: () => navigate(getCompetencyUrl('stress / anxiety')),
        tool: tools?.find((tool) => tool.tool_id === 'navigating_stress'),
      },
      sleep_restoration: {
        title: BE_WELL_STRINGS.actionStickerCards.sleepRestoration.title,
        description: BE_WELL_STRINGS.actionStickerCards.sleepRestoration.description,
        stickerUrl: SleepCloud,
        keywords: ['sleep', 'restoration', 'wellness', 'sleep hygiene', 'sleep quality'],
        onClick: () => navigate(getCompetencyUrl('Sleep / Restoration')),
        tool: tools?.find((tool) => tool.tool_id === 'sleep_restoration'),
      },
      family_dynamics: {
        title: BE_WELL_STRINGS.actionStickerCards.familyDynamics.title,
        description: BE_WELL_STRINGS.actionStickerCards.familyDynamics.description,
        stickerUrl: Merchandise,
        keywords: ['family', 'relationships', 'communication', 'support', 'wellness'],
        onClick: () => navigate(getCompetencyUrl('Family Dynamics')),
        tool: tools?.find((tool) => tool.tool_id === 'family_dynamics'),
      },
      healthcare: {
        title: BE_WELL_STRINGS.actionStickerCards.healthcare.title,
        description: BE_WELL_STRINGS.actionStickerCards.healthcare.description,
        stickerUrl: Flag,
        keywords: ['healthcare', 'access', 'wellness', 'medical', 'treatment'],
        onClick: () => navigate(getCompetencyUrl('Accessing Healthcare')),
        tool: tools?.find((tool) => tool.tool_id === 'healthcare'),
      },
      agency: {
        title: MASTER_MINDSETS_STRINGS.actionStickerCards.agency.title,
        description: MASTER_MINDSETS_STRINGS.actionStickerCards.agency.description,
        stickerUrl: DancingShoes,
        keywords: ['agency', 'independence', 'control', 'wellness', 'health'],
        onClick: () => navigate(getCompetencyUrl('Agency')),
        tool: tools?.find((tool) => tool.tool_id === 'agency'),
      },
      learn_to_learn: {
        title: MASTER_MINDSETS_STRINGS.actionStickerCards.learnToLearn.title,
        description: MASTER_MINDSETS_STRINGS.actionStickerCards.learnToLearn.description,
        stickerUrl: CraftsDIY,
        keywords: ['learning', 'growth', 'development', 'skills', 'education'],
        onClick: () => navigate(getCompetencyUrl('Learning')),
        tool: tools?.find((tool) => tool.tool_id === 'learn_to_learn'),
      },
      growth_mindset: {
        title: MASTER_MINDSETS_STRINGS.actionStickerCards.growthMindset.title,
        description: MASTER_MINDSETS_STRINGS.actionStickerCards.growthMindset.description,
        stickerUrl: ThumbsUp,
        keywords: ['growth', 'mindset', 'success', 'learning', 'development'],
        onClick: () => navigate(getCompetencyUrl('Growth Mindset')),
        tool: tools?.find((tool) => tool.tool_id === 'growth_mindset'),
      },
      problem_solving: {
        title: MASTER_MINDSETS_STRINGS.actionStickerCards.problemSolve.title,
        description: MASTER_MINDSETS_STRINGS.actionStickerCards.problemSolve.description,
        stickerUrl: Calendar,
        keywords: ['problem', 'solving', 'critical', 'thinking', 'decision-making'],
        onClick: () => navigate(getCompetencyUrl('Problem Solving')),
        tool: tools?.find((tool) => tool.tool_id === 'problem_solving'),
      },
      resume_optimizer: {
        title: BUILD_STRONG_PROFILE_STRINGS.actionStickerCards.resumeOptimizer.title,
        description: BUILD_STRONG_PROFILE_STRINGS.actionStickerCards.resumeOptimizer.description,
        stickerUrl: Resume,
        keywords: ['resume', 'optimizer', 'job', 'application', 'career'],
        onClick: () =>
          navigate(
            APP_ROUTE.OFFICE_HOURS_SESSION.replace(
              ':id',
              OFFICE_HOURS_SESSION_IDS.RESUME_OPTIMIZER,
            ),
          ),
        tool: tools?.find((tool) => tool.tool_id === 'resume_optimizer'),
      },
      majors_and_courses: {
        title: BUILD_STRONG_PROFILE_STRINGS.actionStickerCards.majorsAndCourses.title,
        description: BUILD_STRONG_PROFILE_STRINGS.actionStickerCards.majorsAndCourses.description,
        stickerUrl: Audiobook,
        keywords: ['classes', 'majors', 'degrees', 'education', 'academic'],
        onClick: () => navigate(APP_ROUTE.MAJORS),
        tool: tools?.find((tool) => tool.tool_id === 'majors_and_courses'),
      },
      majors: {
        title: GREAT_COLLEGE_STRINGS.actionStickerCards.majors.title,
        description: GREAT_COLLEGE_STRINGS.actionStickerCards.majors.description,
        stickerUrl: GradCap,
        keywords: ['classes', 'majors', 'degrees', 'education', 'academic'],
        onClick: () => navigate(`${APP_ROUTE.OFFICE_HOURS}/majors`),
        tool: tools?.find((tool) => tool.tool_id === 'majors'),
      },
      studying: {
        title: BUILD_STRONG_PROFILE_STRINGS.actionStickerCards.studying.title,
        description: BUILD_STRONG_PROFILE_STRINGS.actionStickerCards.studying.description,
        stickerUrl: Studying,
        keywords: ['studying', 'learning', 'focus', 'academic', 'education'],
        onClick: () => navigate(getCompetencyUrl('Studying')),
        tool: tools?.find((tool) => tool.tool_id === 'studying'),
      },
      boost_your_profile: {
        title: TOOLS_CARD_TITLES.boostYourProfile,
        description: BUILD_STRONG_PROFILE_STRINGS.actionStickerCards.boostYourProfile.description,
        stickerUrl: DesignTech,
        keywords: ['profile', 'boost', 'networking', 'social', 'career'],
        onClick: () =>
          navigate(
            APP_ROUTE.OFFICE_HOURS_SESSION.replace(
              ':id',
              OFFICE_HOURS_SESSION_IDS.BOOST_YOUR_PROFILE,
            ),
          ),
        tool: tools?.find((tool) => tool.tool_id === 'boost_your_profile'),
      },
      tracks_to_succeed: {
        title: EXPLORE_CAREER_STRINGS.actionStickerCards.tracksToSucceed.title,
        description: EXPLORE_CAREER_STRINGS.actionStickerCards.tracksToSucceed.description,
        stickerUrl: RocketShip,
        keywords: ['career', 'tracks', 'success', 'aspirations', 'goals'],
        onClick: () => navigate(APP_ROUTE.CAREER_TRACKS),
        tool: tools?.find((tool) => tool.tool_id === 'tracks_to_succeed'),
      },
      shadowing: {
        title: EXPLORE_CAREER_STRINGS.actionStickerCards.shadowing.title,
        description: EXPLORE_CAREER_STRINGS.actionStickerCards.shadowing.description,
        stickerUrl: ContactCard,
        keywords: ['shadowing', 'mentorship', 'learning', 'career', 'development'],
        onClick: () => navigate(getCompetencyUrl('Shadowing')),
        tool: tools?.find((tool) => tool.tool_id === 'shadowing'),
      },
      jobs_paths_for_you: {
        title: EXPLORE_CAREER_STRINGS.actionStickerCards.jobsPathsForYou.title,
        description: EXPLORE_CAREER_STRINGS.actionStickerCards.jobsPathsForYou.description,
        stickerUrl: JobsPaths,
        keywords: ['career', 'paths', 'life', 'aspirations', 'preferences'],
        onClick: () => navigate(APP_ROUTE.CAREER_PATHS),
        tool: tools?.find((tool) => tool.tool_id === 'jobs_paths_for_you'),
      },
      success_decoded: {
        title: EXPLORE_CAREER_STRINGS.actionStickerCards.successDecoded.title,
        description: EXPLORE_CAREER_STRINGS.actionStickerCards.successDecoded.description,
        stickerUrl: Computer,
        keywords: ['success', 'decoded', 'life', 'aspirations', 'preferences'],
        onClick: () => navigate(APP_ROUTE.COMING_SOON),
        tool: tools?.find((tool) => tool.tool_id === 'success_decoded'),
      },
      networking: {
        title: BUILD_SOCIAL_CAPITAL_STRINGS.actionStickerCards.networking.title,
        description: BUILD_SOCIAL_CAPITAL_STRINGS.actionStickerCards.networking.description,
        stickerUrl: Microphone,
        keywords: ['networking', 'social', 'career', 'development', 'connections'],
        onClick: () => navigate(getCompetencyUrl('Networking')),
        tool: tools?.find((tool) => tool.tool_id === 'networking'),
      },
      seek_support: {
        title: BUILD_SOCIAL_CAPITAL_STRINGS.actionStickerCards.seekSupport.title,
        description: BUILD_SOCIAL_CAPITAL_STRINGS.actionStickerCards.seekSupport.description,
        stickerUrl: MagnifyingGlass,
        keywords: ['support', 'seeking', 'help', 'wellness', 'health'],
        onClick: () => navigate(getCompetencyUrl('Seeking support')),
        tool: tools?.find((tool) => tool.tool_id === 'seek_support'),
      },
      engage_teachers: {
        title: BUILD_SOCIAL_CAPITAL_STRINGS.actionStickerCards.engageTeachers.title,
        description: BUILD_SOCIAL_CAPITAL_STRINGS.actionStickerCards.engageTeachers.description,
        stickerUrl: Waving,
        keywords: ['teachers', 'learning', 'education', 'academic', 'support'],
        onClick: () => navigate(getCompetencyUrl('Engaging teachers')),
        tool: tools?.find((tool) => tool.tool_id === 'engage_teachers'),
      },

      // onboarding specific cards
      back_individual_student: {
        title: 'Back an individual student by joining their panel',
        stickerUrl: Launch,
        keywords: ['back', 'student', 'panel', 'wholeme', 'pre-matching'],
        onClick: () => window.open(`${BACKRS_APP_URL}/wholeme/pre-matching`, '_blank'),
        tool: tools?.find((tool) => tool.tool_id === 'back_individual_student'),
      },
      engage_in_networks: {
        title: 'Engage in networks with others via shared affinity',
        stickerUrl: Comedy,
        keywords: ['engage', 'networks', 'shared', 'affinity', 'connections'],
        onClick: () => window.open(`${BACKRS_APP_URL}/tabs/feed`, '_blank'),
        tool: tools?.find((tool) => tool.tool_id === 'engage_in_networks'),
      },
      respond_to_catch_up: {
        title: 'Quickly respond to or pass on student questions',
        stickerUrl: DesignTechGreen,
        keywords: ['respond', 'catch-up', 'student', 'questions', 'quick'],
        onClick: () => window.open(`${BACKRS_APP_URL}/catchup`, '_blank'),
        tool: tools?.find((tool) => tool.tool_id === 'respond_to_catch_up'),
      },
      explore_tools_dashboard: {
        title: 'Explore tools that could support students',
        stickerUrl: Chances,
        keywords: ['tools', 'dashboard', 'support', 'student', 'career'],
        onClick: () => navigate(APP_ROUTE.HOME),
        tool: tools?.find((tool) => tool.tool_id === 'explore_tools_dashboard'),
      },
      share_your_story_video_ask: {
        title: 'Share your story with a recorded mini interview',
        stickerUrl: VideoCamera,
        keywords: ['story', 'video', 'interview', 'profile', 'career'],
        onClick: () => window.open(`${BACKRS_APP_URL}/tabs/profile?mode=story`, '_blank'),
        tool: tools?.find((tool) => tool.tool_id === 'share_your_story_video_ask'),
      },

      // PAGES
      life_readiness: {
        title: TOOLS_CARD_TITLES.lifeReadiness,
        description: 'How life ready are you? Take the assessment to find out.',
        stickerUrl: Computer,
        keywords: ['life', 'readiness', 'assessment', 'wellness', 'health'],
        onClick: () => navigate(APP_ROUTE.LIFE_READINESS),
        tool: tools?.find((tool) => tool.tool_id === 'life_readiness'),
      },
      blueprint: {
        title: TOOLS_CARD_TITLES.blueprint,
        description: 'Achieve the life that you aspire to',
        stickerUrl: Launch,
        keywords: ['blueprint', 'life', 'aspirations', 'goals', 'planning'],
        onClick: () => navigate(APP_ROUTE.MY_BLUEPRINT),
        tool: tools?.find((tool) => tool.tool_id === 'blueprint'),
      },
      are_you_on_track: {
        title: 'Are You On Track?',
        description: 'Check if you are on track for the life you want',
        stickerUrl: DataChart,
        keywords: ['track', 'assessment', 'progress', 'goals', 'life'],
        onClick: () => navigate(APP_ROUTE.ASSESS_MY_TRACK),
        tool: tools?.find((tool) => tool.tool_id === 'are_you_on_track'),
      },

      // the sticker versions of the image card (used on Onboarding recommendations)
      discover_jobs_sticker: {
        title: EXPLORE_OPPORTUNITIES_STRINGS.imageCards.discoverJobsInternships.title,
        description: EXPLORE_OPPORTUNITIES_STRINGS.imageCards.discoverJobsInternships.description,
        stickerUrl: JobsPaths,
        keywords: ['jobs', 'internships', 'career', 'opportunities', 'explore'],
        onClick: () => navigate(`${APP_ROUTE.SEARCH}/${SEARCH_PAGE_CATEGORIES.INTERNSHIPS}`),
        tool: tools?.find((tool) => tool.tool_id === 'discover_jobs_sticker'),
      },
      explore_universities_sticker: {
        title: EXPLORE_OPPORTUNITIES_STRINGS.imageCards.exploreUniversities.title,
        description: EXPLORE_OPPORTUNITIES_STRINGS.imageCards.exploreUniversities.description,
        stickerUrl: Studying,
        keywords: ['universities', 'colleges', 'education', 'explore', 'opportunities'],
        onClick: () => navigate(`${APP_ROUTE.SEARCH}/${SEARCH_PAGE_CATEGORIES.COLLEGES}`),
        tool: tools?.find((tool) => tool.tool_id === 'explore_universities_sticker'),
      },
      explore_employers_sticker: {
        title: EXPLORE_OPPORTUNITIES_STRINGS.imageCards.exploreEmployers.title,
        description: EXPLORE_OPPORTUNITIES_STRINGS.imageCards.exploreEmployers.description,
        stickerUrl: ContactCard,
        keywords: ['employers', 'companies', 'jobs', 'explore', 'opportunities'],
        onClick: () => navigate(`${APP_ROUTE.SEARCH}/${SEARCH_PAGE_CATEGORIES.EMPLOYERS}`),
        tool: tools?.find((tool) => tool.tool_id === 'explore_employers_sticker'),
      },
      find_scholarships_sticker: {
        title: EXPLORE_OPPORTUNITIES_STRINGS.imageCards.findScholarships.title,
        description: EXPLORE_OPPORTUNITIES_STRINGS.imageCards.findScholarships.description,
        stickerUrl: MagnifyingGlass,
        keywords: ['scholarships', 'financial', 'aid', 'explore', 'opportunities'],
        onClick: () => navigate(`${APP_ROUTE.SEARCH}/${SEARCH_PAGE_CATEGORIES.SCHOLARSHIPS}`),
        tool: tools?.find((tool) => tool.tool_id === 'find_scholarships_sticker'),
      },
      majors_to_careers: {
        title: 'Majors → Career Paths',
        description: 'Discover the relevance between college majors and career paths',
        stickerUrl: '/images/Majors_Careers_Sticker.png',
        keywords: ['majors', 'careers', 'paths', 'explore'],
        onClick: () => navigate('/majors/explorer?mode=majors'),
        tool: tools?.find((tool) => tool.tool_id === 'majors_to_careers'),
      },
      explore_majors: {
        title: 'Explore Majors',
        description: 'Search through over 200 common majors',
        stickerUrl: '/images/light_bulb_sticker.png',
        keywords: ['majors', 'explore', 'search'],
        onClick: () => navigate('/search/majors'),
        tool: tools?.find((tool) => tool.tool_id === 'explore_majors'),
      },
      careers_to_majors: {
        title: 'Career Paths → Majors',
        description: 'Discover which majors most career paths expect or require',
        stickerUrl: '/images/careerPaths_majors_sticker.png',
        keywords: ['careers', 'majors', 'paths', 'explore'],
        onClick: () => navigate('/majors/explorer'),
        tool: tools?.find((tool) => tool.tool_id === 'careers_to_majors'),
      },
    };

    return toolMap({
      tools,
      toolId: id,
      fallback: TOOL_FALLBACKS[id],
      navigate,
    });
  };

  const getImageCard = (id: ImageCardId): ImageCard => {
    const fallback: Record<ImageCardId, ImageCard> = {
      explore_universities_sticker: {
        title: EXPLORE_OPPORTUNITIES_STRINGS.imageCards.exploreUniversities.title,
        description: EXPLORE_OPPORTUNITIES_STRINGS.imageCards.exploreUniversities.description,
        imageUrl: ExploreUniversities,
        keywords: ['universities', 'colleges', 'schools', 'education'],
        onClick: () => navigate(`${APP_ROUTE.SEARCH}/${SEARCH_PAGE_CATEGORIES.COLLEGES}`),
      },
      explore_employers_sticker: {
        title: EXPLORE_OPPORTUNITIES_STRINGS.imageCards.exploreEmployers.title,
        description: EXPLORE_OPPORTUNITIES_STRINGS.imageCards.exploreEmployers.description,
        imageUrl: ExploreEmployers,
        keywords: ['employers', 'companies', 'jobs', 'work', 'explore'],
        onClick: () => navigate(`${APP_ROUTE.SEARCH}/${SEARCH_PAGE_CATEGORIES.EMPLOYERS}`),
      },
      discover_jobs_sticker: {
        title: EXPLORE_OPPORTUNITIES_STRINGS.imageCards.discoverJobsInternships.title,
        description: EXPLORE_OPPORTUNITIES_STRINGS.imageCards.discoverJobsInternships.description,
        imageUrl: ExploreInternships,
        keywords: ['jobs', 'internships', 'career', 'work'],
        onClick: () => navigate(`${APP_ROUTE.SEARCH}/${SEARCH_PAGE_CATEGORIES.INTERNSHIPS}`),
      },
      find_scholarships_sticker: {
        title: EXPLORE_OPPORTUNITIES_STRINGS.imageCards.findScholarships.title,
        description: EXPLORE_OPPORTUNITIES_STRINGS.imageCards.findScholarships.description,
        imageUrl: ExploreScholarships,
        keywords: ['scholarships', 'financial aid', 'grants', 'money'],
        onClick: () => navigate(`${APP_ROUTE.SEARCH}/${SEARCH_PAGE_CATEGORIES.SCHOLARSHIPS}`),
      },
      majors_and_courses: {
        title: TOOLS_CARD_TITLES.collegeMajorGuide,
        description: EXPLORE_OPPORTUNITIES_STRINGS.imageCards.majors.description,
        imageUrl: ExploreMajors,
        keywords: ['majors', 'calculator', 'degree', 'field of study'],
        onClick: () => navigate(APP_ROUTE.MAJORS),
      },
      competency_library: {
        title: EXPLORE_OPPORTUNITIES_STRINGS.imageCards.library.title,
        description: EXPLORE_OPPORTUNITIES_STRINGS.imageCards.library.description,
        imageUrl: CompetencyLibrary,
        keywords: ['competencies', 'skills', 'library', 'resources'],
        onClick: () => navigate(APP_ROUTE.LIBRARY),
      },
      life_readiness: {
        title: EXPLORE_OPPORTUNITIES_STRINGS.imageCards.lifeReadiness.title,
        description: EXPLORE_OPPORTUNITIES_STRINGS.imageCards.lifeReadiness.description,
        imageUrl: LifeReadiness,
        keywords: ['life', 'readiness', 'assessment', 'skills'],
        onClick: () => navigate(APP_ROUTE.LIFE_READINESS),
      },
      jobs_paths_for_you: {
        title: 'Career Paths',
        description: 'Best practices to score an internship or the dream gig.',
        imageUrl: CareerPaths,
        keywords: ['career', 'paths', 'jobs', 'internships'],
        onClick: () => navigate(APP_ROUTE.CAREER_PATHS),
      },
    };

    const card = fallback[id];
    const foundTool = tools?.find((tool) => tool.tool_id === id);

    if (!foundTool) return card;

    return {
      ...card,
      title: foundTool.title || card.title,
      description: foundTool.description || card.description,
      imageUrl: foundTool.banner_media?.media_url || card.imageUrl,
    };
  };

  return { getStickerCard, getImageCard };
};
